import component from "./ProfileAlert.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileAlert"

export default wrapVueComponent(componentName, component)
